module.exports = __webpack_public_path__ + "media/LandingPageAssets/charm_cross-041ab6cb.svg";